import { InjectorService } from '../classes/injector-service.js';
import { ProviderRegistry } from '../classes/provider.js';

/**
 * jest 完成回调
 * @public
 */
const Done = Symbol('jest:done');
/**
 * An injection helper for jest
 *
 * @public
 */
function inject(targets, func) {
    InjectorService.buildRegistry(ProviderRegistry, p => p.instance === undefined);
    return (done) => {
        let isDoneInjected = false;
        const args = targets.map((target) => {
            if (target === Done) {
                isDoneInjected = true;
                return done;
            }
            if (!InjectorService.has(target)) {
                InjectorService.construct(target);
            }
            return InjectorService.get(target);
        });
        func(...args);
        if (!isDoneInjected)
            done();
    };
}

export { Done, inject };
//# sourceMappingURL=inject.js.map
